import * as React from 'react';
import classNames from 'classnames';
import Button, { IButtonProps } from '@/components/ui/Button';
import Icon, { IconsAvailable } from '@/components/ui/Icon';
import Buttons from '@/components/ui/Buttons';
import SimpleImage from '@/components/ui/SimpleImage';
import ButtonActivatePackage from '@/components/paywall/button';
import './styles.scss';

export interface IPromoProps {
  children: React.ReactNode;
  buttons?: IButtonProps[];
  buttonAsComponentTitle?: string;
  icon?: IconsAvailable;
  image?: string;
}

const Promo: React.FunctionComponent<IPromoProps> = (props) => {
  return (
    <div className={classNames('promo')}>
      <div className={'promo__text'}>
        {props.icon && (
          <div className={classNames('promo__heading')}>
            <Icon
              width={76}
              height={76}
              kind={props.icon}
              className={'promo__icon'}
            />
            {props.buttons && props.buttons.length > 0 && !props.image && (
              <Buttons>
                {props.buttons.map((button, i) => (
                  <Button
                    size="medium"
                    key={i}
                    {...button}
                  />
                ))}
              </Buttons>
            )}
            {props.buttonAsComponentTitle && !props.buttons && !props.image && (
              <ButtonActivatePackage title={props.buttonAsComponentTitle} />
            )}
          </div>
        )}

        {props.children}

        {props.buttons && props.buttons.length > 0 && !props.icon && (
          <Buttons>
            {props.buttons.map((b, bi) => (
              <Button
                size="medium"
                key={bi}
                {...b}
              />
            ))}
          </Buttons>
        )}
        {props.buttonAsComponentTitle && !props.buttons && !props.icon && <ButtonActivatePackage title={props.buttonAsComponentTitle} />}
      </div>
      {props.image && (
        <div className={'promo__image'}>
          <SimpleImage
            url={props.image}
            aspectRatio={1}
            alt=""
          />
        </div>
      )}
    </div>
  );
};

Promo.displayName = 'Promo';

export default Promo;
